/* esm.sh - @noble/ciphers@2.2.0/_poly1305 */
export * from "/*@noble/ciphers@2.2.0/esnext/_poly1305.mjs";
